import { PipeTransform } from '@angular/core';
var DynamoRiskCleanupPipe = /** @class */ (function () {
    function DynamoRiskCleanupPipe() {
        this.charactersToReplace = ['|'];
    }
    DynamoRiskCleanupPipe.prototype.transform = function (value) {
        this.charactersToReplace.forEach(function (element) {
            value = value.split(element).join(' ');
        });
        return value;
    };
    return DynamoRiskCleanupPipe;
}());
export { DynamoRiskCleanupPipe };
